import { Player, RosterPositionEnum } from '../../sdk/model';

/**
 * Creates a sorting function for player positions based on the given position order
 * Row must include a "player" column with a Player object
 * @param positionOrder The order of positions to sort by (e.g., positionOrderNoBench)
 * @returns A sorting function that can be used with table sorting
 */
export const positionSorter = (positionOrder: RosterPositionEnum[]) => {
  return (rowA: any, rowB: any) => {
    const playerA = rowA?.original?.player as Player | undefined;
    const playerB = rowB?.original?.player as Player | undefined;
    
    if (playerA) {
      if (playerB) {
        return positionOrder.indexOf(playerA.position) - positionOrder.indexOf(playerB.position);
      }
      return 1;
    } 
    return 0;
  };
};
